/** Strip HTML tags for AI plain-text input. */
export function stripHtmlForAi(html: string): string {
  if (!html) return '';
  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n');
  const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
  return (doc.body.textContent || '').replace(/\u00a0/g, ' ').trim();
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Convert AI plain-text output back into simple HTML for RichTextArea. */
export function plainTextToRichHtml(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return '';
  if (/<[a-z][\s\S]*>/i.test(trimmed)) return trimmed;
  const blocks = trimmed.split(/\n{2,}/);
  return blocks
    .map((block) => {
      const lines = block.split('\n').map((line) => escapeHtml(line.trim())).filter(Boolean);
      if (!lines.length) return '';
      return `<p>${lines.join('<br>')}</p>`;
    })
    .filter(Boolean)
    .join('');
}

export function hasRichTextContent(html: string): boolean {
  return stripHtmlForAi(html).length > 0;
}
